import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import { UserDetailsContextProvider } from "./context/auth";
import LoadingContext from "./context/loading";
import "./index.css";
import { DesignationProvider } from "./context/designationcontext";
//Redux config
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/store";
import { DialogProvider } from "./context/dialogContext";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

// console.log = () => {};
// console.warn = () => {};
// console.error = () => {};

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <MaterialUIControllerProvider>
          <UserDetailsContextProvider>
            <LoadingContext>
              <DialogProvider>
                <DesignationProvider>
                  <App />
                </DesignationProvider>
              </DialogProvider>
            </LoadingContext>
          </UserDetailsContextProvider>
        </MaterialUIControllerProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
